import { downLoadFile, usePrevious } from "@/utils/chat/index";
import { Button, Drawer, Form, Input, Radio, Tooltip, message, message as toast } from "antd";
import React, { useCallback, useEffect, useMemo, useState, useRef, useContext } from "react";
import styles from "./index.module.less";
import IconFont from "@/components/icon";
import { get } from "lodash";
import { AI_CHAT_PREDICT, ChatMessage, ChatMessageType } from "@/types/chat";
import { connect } from "dvajs";
import {
  AICHAT_MSG_TIP_KEY,
  buildAIChatMessageComm,
  getFileDownloadBzId,
  getFileDownloadBzType,
  initChatMessageInfo,
  isImagePredictType,
  preivewFileWPS,
  sleep
} from "@/utils/chat/message";
import { createUploadTask } from "@/server/FileService";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { nanoid } from "nanoid";
import { FocusSDK } from "@/utils";
import { TaskState } from "@jd/jdee-fs-desktop";
import eventEmitter from "@/utils/bus";
import { canJoyspacePreview } from "@/components/Joyspace/util";
export const buildMessage = async (data: {
  files: any[];
  sessionId: string;
  currentEmployee: any;
  content: string;
  predictType?: AI_CHAT_PREDICT;
}) => {
  const {
    files,
    sessionId,
    currentEmployee,
    content,
    predictType = AI_CHAT_PREDICT.FILE_SUMMARY
  } = data;

  if (!files?.length) return;
  const message: any = {
    content,
    files
  };
  const msg = await buildAIChatMessageComm({
    sessionId: sessionId,
    currentEmployee,
    predictType: predictType || AI_CHAT_PREDICT.FILE_SUMMARY,
    prompt: "",
    message
  });
  return msg;
};

function LLMFiles(props: any) {
  const {
    files,
    updateLLMInfo,
    selectedSession,
    currentEmployee,
    pushChatMessage,
    llmInfoReady
  } = props;
  const { appRuntimeEnv } = useContext<GlobalContextConfig>(GlobalContext);
  const [hoverId, setHoverId] = useState<number | null>(null);
  const {
    fileService: { imAppKey },
    joyspaceApiHost,
    joyspaceHost
  } = appRuntimeEnv;

  useEffect(() => {
    files.map((file: any) => {
      // console.log("files>ls", file);
      const { fileName, pageType, type } = file;
      if (!file.fileId) {
        file.fileId = nanoid(10);
      }

      if (file.isUpload && !file.task) {
        const task = createUploadTask(file.fileId, file.file, {
          appKey: imAppKey,
          bizType: getFileDownloadBzType(selectedSession),
          bizId: getFileDownloadBzId(selectedSession)
        });
        file.task = task;
        task?.on("state", (state: any) => {
          // console.log("stateFiles>ls", state, file);
          if (state.state === TaskState.UPLOADING) {
            file.state = state.state;
            FocusSDK.emit("files-change", {
              fileId: file.fileId
            });
            // console.log("state>ls", state, file);
          }
          if (state.state === TaskState.COMPLETED) {
            file.state = state.state;
            file.url = state.downloadUrl;
            FocusSDK.emit("files-change", {
              fileId: file.fileId
            });
            // console.log("state>ls", state, file);
          }
          if (state.state === TaskState.FAILED) {
            file.state = state.state;
            FocusSDK.emit("files-change", {
              fileId: file.fileId
            });
            message.warning("上传失败，请重新上传");
            // 处理上传失败状态变化
          }
        });
        task?.start();
        // console.log("task>ls", task);
      }
    });
    //  console.log("fileslength>ls", files.length);
  }, [files, imAppKey]);

  const changeFiles = useCallback(
    ({ fileId, url }) => {
      //  console.log("changeFiles>ls", fileId, url, files);
      //   files.map((file: any) => {
      //     if (fileId === file.fileId) {
      //       file.url = url;
      //     }
      //   });
      updateLLMInfo({ files });
    },
    [files, updateLLMInfo]
  );
  useEffect(() => {
    FocusSDK.on("files-change", changeFiles);
    return () => {
      FocusSDK.off("files-change", changeFiles);
    };
  }, [changeFiles]);
  const handleDelete = useCallback(
    (id) => {
      const newFiles = files.filter((file: any) => {
        return file.fileId !== id;
      });
      updateLLMInfo({
        files: newFiles
      });
    },
    [updateLLMInfo, files]
  );
  useEffect(() => {
    eventEmitter.on("llmFiles-delete", handleDelete);
    return () => {
      eventEmitter.off("llmFiles-delete", handleDelete);
    };
  }, [handleDelete]);

  const getIcon = useCallback(
    (file, index) => {
      console.log(hoverId, "hoverId", file.fileId);
      if (hoverId !== file.fileId) {
        if (file.state === TaskState.UPLOADING) {
          return <IconFont type="iconic_repeat" className={styles["icon-repeat"]} />;
        }
        if (file.state === TaskState.FAILED) {
          return (
            <IconFont
              type="iconic_pc_hint"
              style={{
                color: "#EE0A24"
              }}
            />
          );
        }
      }
      return (
        <IconFont
          type="iconjs_ic_error"
          onClick={(e) => {
            e.stopPropagation();
            eventEmitter.emit("llmFiles-delete", file.fileId);
            setHoverId(null);
          }}
        />
      );
    },
    [handleDelete, hoverId]
  );
  const sendFileSummary = useCallback(async () => {
    if (!llmInfoReady) return;
    const message = await buildMessage({
      files,
      sessionId: selectedSession.sessionId,
      currentEmployee,
      content: "请根据以下材料，自动生成摘要",
      predictType: AI_CHAT_PREDICT.FILE_SUMMARY
    });
    // console.log("sendSummarymessage>ls", message);
    pushChatMessage({ sessionId: selectedSession.sessionId, message });
    updateLLMInfo(null);
  }, [
    llmInfoReady,
    files,
    selectedSession.sessionId,
    currentEmployee,
    pushChatMessage,
    updateLLMInfo
  ]);
  const handleClick = (file: any) => {

    console.log(file, "test");
    if (!file.isUpload && file.url) {
      window.open(file.url);
      return;
    }
    if (file.isUpload && file.url) {
      if (canJoyspacePreview(file.fileName)) {
        return preivewFileWPS({ appKey: imAppKey, downloadUrl: file.url }, { joyspaceHost });
      }
      return downLoadFile(file.fileName, file.url);
    }
  };

  const sendWorkSummary = useCallback(async () => {
    if (!llmInfoReady) return;
    const message = await buildMessage({
      files,
      sessionId: selectedSession.sessionId,
      currentEmployee,
      content: "请根据以下材料，自动生成周报",
      predictType: AI_CHAT_PREDICT.WORK_SUMMARY
    });
    // console.log("sendSummarymessage>ls", message);
    pushChatMessage({ sessionId: selectedSession.sessionId, message });
    updateLLMInfo(null);
  }, [
    llmInfoReady,
    files,
    selectedSession.sessionId,
    currentEmployee,
    pushChatMessage,
    updateLLMInfo
  ]);
  if (!files?.length) return null;

  return (
    <div className={styles["chat-files"]}>
      <div className={styles["chat-files-wrap"]}>
        {files.map((file: any, index: number) => {
          return (
            <div
              key={`file_${file.fileId || index}`}
              className={styles["chat-files-item"]}
              onMouseEnter={() => {
                setHoverId(file.fileId);
              }}
              onMouseLeave={() => {
                setHoverId(null);
              }}
              onClick={() => {
                handleClick(file);
              }}
            >
              <img
                src={
                  file.icon ||
                  `${joyspaceApiHost}/v1/common/icons?title=${encodeURIComponent(
                    file.fileName
                  )}&pageType=${file.pageType || 6}&client=web`
                }
              />
              <div className={styles["item-title"]}>
                <Tooltip title={file.fileName}>{file.fileName}</Tooltip>
              </div>
              <div className={styles["item-icon"]}>{getIcon(file, index)}</div>
            </div>
          );
        })}
      </div>
      <div
        className={
          llmInfoReady
            ? styles["chat-files-control"]
            : `${styles["chat-files-control"]} ${styles["chat-files-control-unReady"]}`
        }
      >
        <div className={styles["btn-back"]} onClick={sendFileSummary}>
          <div className={styles["btn-inner"]}>
            <div className={styles["text"]}>
              <IconFont type="iconic_pc_disorder" />
              摘要总结
            </div>
          </div>
        </div>
        <div className={styles["btn-back"]} onClick={sendWorkSummary}>
          <div className={styles["btn-inner"]}>
            <div className={styles["text"]}>
              <IconFont type="iconjilu" className={styles["anticon1"]} />
              生成周报
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps({ chat }: any) {
  return {
    selectedSession: chat.selectedSession,
    currentEmployee: chat.currentEmployee,
    files: chat.llmInfo?.files,
    llmInfoReady: chat.llmInfo?.isReady
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    updateLLMInfo(data: any) {
      dispatch({ type: "chat/updateLLMInfo", payload: data });
    },
    pushChatMessage(data: { sessionId: string; message: Partial<ChatMessage> }) {
      dispatch({ type: "chat/pushChatMessage", payload: data });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(LLMFiles);
